import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/2c5c79c7/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Community components`}</h2>
    <p>{`These components are developed and maintained by members of the Carbon community. For support, contact the contributors listed on each page. They are not supported by the core Carbon team.`}</p>
    <p>{`These components may change over time, and they may be incomplete or experimental. For work that has been approved for universal use by the Carbon governance board, see `}<a parentName="p" {...{
        "href": "/components/overview"
      }}>{`Carbon components`}</a>{`.`}</p>
    <p><em parentName="p">{`This content is accessible to IBMers only.`}</em></p>
    <br />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Community components`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://pages.github.ibm.com/cdai-design/pal/components/card/usage"
            }}>{`Cards`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Accessible to IBMers only.`}</em>{` A flexible container that groups related blocks of content and information into one understandable unit.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://pages.github.ibm.com/cdai-design/pal/components/widget/usage"
            }}>{`Widget`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Accessible to IBMers only.`}</em>{` Provides a summary of a platform functionality, status, or individual service.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      